/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.CustomAssistantsService
 */

/**
 *  Represents a conversation starter with optional metadata.
 *  This allows for rich conversation starters with titles, descriptions, labels,
 *  and extensibility for future metadata fields.
 */

/**
 *  Custom Assistant - the new v2 model for portal-specific assistants
 */

/**
 *  Summary view of a Custom Assistant for list responses
 *  Contains essential information without heavy details like full resource configurations
 */

/**
 *  CHIRP-safe version of CustomAssistantPermissionWithUserTeamPermissions that excludes portalId.
 *  The portalId is accessed from ChirpContext instead.
 */

/**
 *  Collection of resource configurations for a Custom Assistant
 */

/**
 *  Configuration for a specific resource type
 */

/**
 *  Request to create a new custom assistant
 */

/**
 *  Response for creating a new custom assistant
 */

/**
 *  Cursor for custom assistants pagination
 */

/**
 *  Request to delete a custom assistant
 */

/**
 *  Response for deleting a custom assistant
 */

/**
 *  Request to duplicate an existing custom assistant
 */

/**
 *  Response for duplicating a custom assistant
 */

/**
 *  Request to get a custom assistant by ID
 */

/**
 *  Response for getting a custom assistant by ID
 */

/**
 *  Request to install a custom assistant template using its global ID
 */

/**
 *  Response for installing a custom assistant template using its global ID
 */

/**
 *  Request to list custom assistants with pagination support
 */

/**
 *  Response for listing custom assistants with pagination
 */

/**
 *  Request to lookup a user's installed assistant by global template ID
 */

/**
 *  Response for looking up a user's installed assistant by global template ID
 */

/**
 *  Request to submit user feedback on a generated prompt/instruction for a custom assistant.
 *  This feedback is used to improve prompt generation quality over time.
 */

/**
 *  Request to update an existing custom assistant
 */

/**
 *  Response for updating a custom assistant
 */

/**
 *  CHIRP-safe version of CustomAssistantPermissionWithUserTeamPermissions for creation requests.
 *  This interface is used during custom assistant creation when the CustomAssistantId doesn't exist yet.
 *  The portalId is accessed from ChirpContext, and the CustomAssistantId will be set after creation.
 */

export const getCustomAssistantRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.CustomAssistantsService',
  rpcName: 'getCustomAssistant',
  auth: 'app',
  fingerprint: 'kAz63WI73cCEXQreR375wjanqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConversationStartersRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.CustomAssistantsService',
  rpcName: 'getConversationStarters',
  auth: 'app',
  fingerprint: 'eJAUqD86GiE_I42kP2itrTanqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listCustomAssistantsRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.CustomAssistantsService',
  rpcName: 'listCustomAssistants',
  auth: 'app',
  fingerprint: 'Eaq2_6bBR5Wbftlo4_LWfDanqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createCustomAssistantRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.CustomAssistantsService',
  rpcName: 'createCustomAssistant',
  auth: 'app',
  fingerprint: 'RKg4LOmqftarCBJflj4gEDanqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const duplicateCustomAssistantRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.CustomAssistantsService',
  rpcName: 'duplicateCustomAssistant',
  auth: 'app',
  fingerprint: 'uMKJE-PN0FhA-W6zxtcCgDanqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateCustomAssistantRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.CustomAssistantsService',
  rpcName: 'updateCustomAssistant',
  auth: 'app',
  fingerprint: 'ZMxP5HrQXgQYHMjOlNDwFDanqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteCustomAssistantRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.CustomAssistantsService',
  rpcName: 'deleteCustomAssistant',
  auth: 'app',
  fingerprint: 'WCuOR3OA9j77e6bFusux0TanqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const installCustomAssistantTemplateFromGlobalIdRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.CustomAssistantsService',
  rpcName: 'installCustomAssistantTemplateFromGlobalId',
  auth: 'app',
  fingerprint: 'F2ItRzL0NWOHeJYOvrg2CTanqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const lookupUserInstalledAssistantByGlobalIdRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.CustomAssistantsService',
  rpcName: 'lookupUserInstalledAssistantByGlobalId',
  auth: 'app',
  fingerprint: 'FUsSZduaZJZ_3NXo29FttzanqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findAssistantsByResourceIdRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.CustomAssistantsService',
  rpcName: 'findAssistantsByResourceId',
  auth: 'app',
  fingerprint: '4RM8nyj3tpKbftlo4_LWfDanqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitPromptFeedbackRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.CustomAssistantsService',
  rpcName: 'submitPromptFeedback',
  auth: 'app',
  fingerprint: 'rKThYVdALqHf-iFjiiqpOTanqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};